<template>
  <section class="" style="padding-top: 1.5rem">
    <div class="container">

      <div class="columns">
        <div class="column"></div>
        <div class="column is-three-quarters">

          <div style="position: relative">

            <transition name="upload-area">
            <div class="vue-dropzone dropzone"
                 key="upload-state"
                 v-show="currentState === uploadStates.upload"
                 style="position: absolute; left: 0; right: 0;">

              <uploadcare publicKey="demopublickey"
                          tabs="file url skydrive gdrive dropbox box evernote"
                          inputAcceptTypes=".pptx"
                          preferredTypes="application/vnd.openxmlformats-officedocument.presentationml.presentation"
                          crop="disabled"
                          :previewStep="true"
                          @success="onUploadcareSuccess" 
                          @error="onUploadcareError">
                <div class="dz-default dz-message" >
                  <span>
                  <i class="ms-Icon ms-Icon--PowerPointDocument" 
                                style="font-size: 3rem;"
                                aria-hidden="true"></i>      
                            <span style="font-size: 1.5rem;
                                        position: relative;
                                        bottom: 0.8rem;
                                        padding-left: 0.7rem;">    
                              Click to choose a file to upload.
                            </span>
                  </span>
                </div>
              </uploadcare>

            </div>            
            </transition>

            <transition name="upload-area">
            <div class="vue-dropzone dropzone"
                key="processing-state"
                v-show="currentState === uploadStates.processing"
                style="position: absolute; left: 0; right: 0;">

              <div class="dz-default dz-message" >
                <span>          
                  <i class="ms-Icon ms-Icon--AdminPLogoInverse32" style="font-size: 3rem;"></i>       
                  <span style="font-size: 1.5rem;
                              position: relative;
                              bottom: 1rem;
                              padding-left: 0.7rem;"> 
                    <span>Processing upload, please wait...</span>   
                    <spinner style="display: inline-block; margin-left: 0.7rem; margin-bottom: -0.7rem;"
                            :size="38"></spinner>
                  </span>
                </span>
              </div>
            </div>
            </transition>
          
            <transition name="upload-area">
            <div class="vue-dropzone dropzone"
                key="success-state"
                v-show="currentState === uploadStates.success"
                style="position: absolute; left: 0; right: 0;">

              <div class="dz-default dz-message" >
                <span v-show="currentState === uploadStates.success">             
                  <i class="ms-Icon ms-Icon--Accept" style="font-size: 2.6rem;"></i>      
                  <span style="font-size: 1.5rem;
                              position: relative;
                              bottom: 0.7rem;
                              padding-left: 0.7rem;"> 
                    <span>Processing complete!</span>  
                  </span>
                </span>

              </div>
            </div>
            </transition>

          </div>

        </div>                
        <div class="column"></div>
      </div>

    </div> 
  </section>  
</template>

<script>
import Uploadcare from '../../vendor/Uploadcare.vue';
import Spinner from '../../vendor/Spinner.vue';

window.UPLOADCARE_PUBLIC_KEY = 'demopublickey';
window.UPLOADCARE_LOCALE = 'en';
window.UPLOADCARE_LOCALE_TRANSLATIONS = {
  dialog: {
    tabs: {
      file: {
        drag: 'Drag and drop a file here'
      },
      preview: {
        unknown: {
          title: 'Uploading... Please wait.',
          done: 'Please wait...'
        }
      }      
    }
  }
};

import axios from 'axios';

export default {
  name: 'UploadSection',
  components: {
    Spinner,
    Uploadcare
  },
  data: function() {
    return {
      uploadStates: {
        'upload': 'upload',
        'processing': 'processing',
        'success': 'success'
      },
      currentState: null,
    };
  },
  mounted() {
    this.currentState = this.uploadStates.upload;
    // this.currentState = this.uploadStates.processing;
    // this.currentState = this.uploadStates.success;
  },
  methods: {
    onUploadcareSuccess(fileInfo) {
      console.log('onUploadcareSuccess: ', fileInfo)

      this.$appInsights.trackEvent('onUploadcareSuccess - Upload complete, awaiting response');
      this.$ga.event('upload', 'complete', 'Create > Upload section');

      this.currentState = this.uploadStates.processing;
      // Send file details to API to load from Uploadcare and process

      axios.post('/api/UploadFromUploadcare', fileInfo)
        .then((response) => {
          console.log(response);
          this.successResult = response.data;
          this.currentState = this.uploadStates.success;          

          this.$appInsights.trackEvent('onUploadcareSuccess - Success uploading to Azure from Uploadcare');
          this.$ga.event('upload', 'success', 'Create > Upload section');

          // Move to next 'step' -> Edit Section
          setTimeout(() => {
            this.$emit('upload-success', this.successResult);
          }, 2000);
        })
        .catch((error) => {
          console.error(error);
          this.showErrorSnackbar();

          this.$appInsights.trackEvent('onUploadcareSuccess - Error uploading to Azure from Uploadcare!', { error: error });
          this.$ga.exception(`Error uploading to Azure from Uploadcare - Error: ${error}`);

          this.currentState = this.uploadStates.upload;                    
        });
    },
    onUploadcareError(error) {
      console.error('onUploadcareError: ', error);
      
      this.showErrorSnackbar();

      this.$appInsights.trackEvent('onUploadcareError - File was not uploaded successfully to Uploadcare', { error: error });
      this.$ga.event('uploadcare', `error - ${error}`, 'Create > Upload section');

      this.currentState = this.uploadStates.upload;
    },
    showErrorSnackbar() {
      this.$snackbar.open({
          message: 'Oops, something went wrong. Please try again.',
          type: 'is-warning',
          position: 'is-top',
          indefinite: false
      })
    }
  }    
};
</script>

<style lang="scss" scoped>
@import "~vue2-dropzone/dist/vue2Dropzone.css";

.dropzone {
  text-align: center;
}

.upload-area-enter-active, .upload-area-leave-active {
  // transition: opacity .5s
  transition: all 1s;
}
.upload-area-enter, .upload-area-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
.upload-area-enter {
  // transform: translateX(50vw);
  transform: translateY(300px);
}
.upload-area-leave-to {
  // transform: translateX(-50vw);
  transform: translateY(-300px);
}

</style>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/create/UploadSection.vue